import React, { createContext, ReactNode, useContext } from 'react';

export type ClientScoreHealthRangeConfig = {
  isTargetRangeEditable: boolean;
};

const ClientScoreHealthRangeContext = createContext<ClientScoreHealthRangeConfig>({
  isTargetRangeEditable: true,
});

export const ClientScoreHealthRangeProvider: React.FC<{ children: ReactNode } & ClientScoreHealthRangeConfig> = ({
  children,
  ...props
}) => {
  return (
    <ClientScoreHealthRangeContext.Provider value={{ ...props }}>{children}</ClientScoreHealthRangeContext.Provider>
  );
};

export const useClientScoreHealthRangeConfig = (): ClientScoreHealthRangeConfig => {
  return useContext(ClientScoreHealthRangeContext);
};
